import { Typography } from "@altimateai/lego";
import { AuditHistory } from "../sso-group-sync/AuditHistory";

export const AuditSettings = () => (
  <div className="al-p-6 al-max-w-6xl al-mx-auto al-space-y-4">
    <Typography variant="page-heading">Audit Log</Typography>
    <Typography variant="body" className="al-text-gray-500">
      View audit events for SSO group sync and other administrative actions.
    </Typography>
    <AuditHistory />
  </div>
);
